import { useLang } from './useLang'

const map = {
  de: process.env.GATSBY_SITE_ID_DE,
  fr: process.env.GATSBY_SITE_ID_FR,
  it: process.env.GATSBY_SITE_ID_IT,
}

export const useSiteId = () => {
  const lang = useLang()

  return Number(map[lang])
}
